"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = void 0;
/** Парсит урл на облачный просмотрщик */
var parseUrl = function (url, urlPartsReg) {
    if (!urlPartsReg.test(url)) {
        return null;
    }
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, searchParams = _a.searchParams;
    var fixedPathname = pathname.replace('/attaches/', '');
    return { host: hostname, attachPath: fixedPathname, queryParams: searchParams };
};
exports.parseUrl = parseUrl;
//# sourceMappingURL=parseUrl.js.map